import { render } from "./vcoursewareclassifyedit.vue?vue&type=template&id=4abfab94&scoped=true"
import script from "./vcoursewareclassifyedit.vue?vue&type=script&lang=js"
export * from "./vcoursewareclassifyedit.vue?vue&type=script&lang=js"

import "./vcoursewareclassifyedit.vue?vue&type=style&index=0&id=4abfab94&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abfab94"]])

export default __exports__